import { DocumentType } from '../types/document-revision-status.types';

export type DocumentRegistrationTabOptionId = 'documentos' | 'registros';

export function isDocumentRegistrationTabOptionId(
  value: string
): value is DocumentRegistrationTabOptionId {
  return value === 'documentos' || value === 'registros';
}

export function documentTypeToTabOptionId(
  documentType: DocumentType
): DocumentRegistrationTabOptionId {
  return documentType === DocumentType.REGISTRATION ? 'registros' : 'documentos';
}

export function tabOptionIdToDocumentType(optionId: DocumentRegistrationTabOptionId): DocumentType {
  return optionId === 'registros' ? DocumentType.REGISTRATION : DocumentType.DOCUMENT;
}
